import gsap from "gsap";

export default () => {
  let page = document.querySelector('body');

  if(page.getAttribute('data-page-name') == 'homePage') {
    gsap.to(page, {
      opacity: 1,
      duration: .8,
    });
  }
}
